<template>
  <div class="container">
    <h3 class="title">Prosimy o opisanie tych okoliczności.</h3>
    <h4
      class="text"
    >(np. podanie konkretnych godzin wizyty {{this.steps[0].value==="help"? "lekarza":"fachowca"}}, utrudnienia itp.)</h4>
    <form @submit.prevent="btnHandler" class="field">
      <input type="text" class="input" v-model="description" />
      <button type="submit" class="arrow">
        <svg
          width="24"
          height="18"
          viewBox="0 0 24 18"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M15.3415 0.247437C15.7571 -0.116245 16.3889 -0.0741276 16.7526 0.341509L23.7526 8.34151C24.0825 8.71853 24.0825 9.28149 23.7526 9.65852L16.7526 17.6585C16.3889 18.0742 15.7571 18.1163 15.3415 17.7526C14.9259 17.3889 14.8837 16.7571 15.2474 16.3415L20.7962 10H1C0.447715 10 0 9.5523 0 9.00001C0 8.44773 0.447715 8.00001 1 8.00001H20.7962L15.2474 1.65852C14.8837 1.24288 14.9259 0.611119 15.3415 0.247437Z"
            :fill="$color"
          />
        </svg>
      </button>
    </form>
  </div>
</template>

<script>
import { mapMutations, mapState } from "vuex";
export default {
  name: "StepAdditionalDescription",
  data() {
    return {
      description: null,
    };
  },
  methods: {
    ...mapMutations(["setUserData", "setAssistanceStep"]),
    btnHandler() {
      this.setUserData({ Comments: this.description });
      this.setAssistanceStep("last");
    },
  },
  computed: {
    ...mapState(["steps"]),
  },
};
</script>

<style scoped lang="scss">
.text {
  font-size: 14px;
  margin-top: 8px;
  text-align: center;
  color: #454545;
  font-weight: 400;
}
</style>



// WEBPACK FOOTER //
// src/components/assistance_steps/StepAdditionalDescription.vue